import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  selectedItem: null,
  lastAction: '',
};

export const reelVideoSlice = createSlice({
  name: 'reelVideoSlice',
  initialState,
  reducers: {
    addReelVideo: (state) => {
      state.loading = true;
      state.error = null;
      state.lastAction = '';
    },
    getReelVideo: (state) => {
      state.loading = true;
      state.error = null;
    },
    getOneReelVideo: (state) => {
      state.loading = true;
      state.error = null;
      state.selectedItem = null;
    },
    successReelVideo: (state, action) => {
      state.loading = false;
      state.error = null;
      state.data = Array.isArray(action.payload?.data) ? action.payload.data : [];
      state.lastAction = action.payload?.action || '';
    },
    successOneReelVideo: (state, action) => {
      state.loading = false;
      state.error = null;
      state.selectedItem = action.payload?.data || null;
      state.lastAction = action.payload?.action || '';
    },
    failedReelVideo: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    removeReelVideo: (state) => {
      state.loading = true;
      state.error = null;
      state.lastAction = '';
    },
    updateReelVideo: (state) => {
      state.loading = true;
      state.error = null;
      state.lastAction = '';
    },
    clearSelectedReelVideo: (state) => {
      state.selectedItem = null;
    },
    clearReelVideoStatus: (state) => {
      state.error = null;
      state.lastAction = '';
    },
  },
});

export const {
  addReelVideo,
  getReelVideo,
  getOneReelVideo,
  successReelVideo,
  successOneReelVideo,
  failedReelVideo,
  removeReelVideo,
  updateReelVideo,
  clearSelectedReelVideo,
  clearReelVideoStatus,
} = reelVideoSlice.actions;

export default reelVideoSlice.reducer;
